const isString = (val: unknown): val is string => {
  return typeof val === 'string' || val instanceof String
}

export { isString }